import { useLocation, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useUser } from '@/firebase';

const publicPaths = ['/login'];

export default function AuthGuard({ children }: { children: React.ReactNode }) {
  const { user, isUserLoading } = useUser();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    if (!isUserLoading && !user && !publicPaths.includes(pathname)) {
      navigate({ to: '/login' });
    }
  }, [user, isUserLoading, navigate, pathname]);

  if (isUserLoading || (!user && !publicPaths.includes(pathname))) {
    // You can show a loading spinner here
    return (
        <div className="flex items-center justify-center h-screen">
            <div className="text-2xl font-semibold">{t('ui.guards.loading')}</div>
        </div>
    );
  }

  if (user && publicPaths.includes(pathname)) {
    navigate({ to: '/' });
    return null;
  }

  return <>{children}</>;
}
